const actions = {
  SET_STATE: 'sport/category/SET_STATE',
  REFRESH_ERRORS: 'sport/category/REFRESH_ERRORS',
  ALL: 'sport/category/ALL',
  FETCH_ALL: 'sport/category/FETCH_ALL',
  DETAILS: 'sport/category/DETAILS',
  ADD: 'sport/category/ADD',
  EDIT: 'sport/category/EDIT',
  REMOVE: 'sport/category/REMOVE'
};

export default actions
